/**
 * Client Signup Trigger Component
 *
 * Trigger: "signed up"
 * No additional fields needed.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const ClientSignupTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.signedUp')}</span>;
  }

  // Edit mode - no fields needed
  return null;
};
